export default __webpack_public_path__ + "static/media/ict-resource-center.f514f8ca.jpg";